module.exports = __webpack_public_path__ + "static/childcouncil_card_img5@2x-324e461f65fe7ad1a77a11587f754b0a.jpg";